import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <footer className="container text-center">
      <p>
        <small>
          QR Code, WhatsApp, Facebook, Google, UPI, PayTM, PhonePe, AmazonPay,
          GPay are registered trademarks of their respective owners.
          InstantQRCodes.com is not affiliated or endorsed by them.
        </small>
      </p>
      <nav className="footer-menu">
        <ul>
          <li>
            <NavLink to="/about/">About</NavLink>
          </li>
          <li>
            <NavLink to="/faqs/">FAQs</NavLink>
          </li>
          <li>
            <NavLink to="/contact/">Contact</NavLink>
          </li>
          <li>
            <NavLink to="/privacy-policy/">Privacy</NavLink>
          </li>
          <li>
            <NavLink to="/terms-conditions/">Terms</NavLink>
          </li>
        </ul>
      </nav>
      &copy; 2022 InstantQRCodes.com
      {/* <div className="mode-swtich">
          Theme:{" "}
          <button
            type="button"
            onClick={() => {
              setChecked(true);
            }}
          >
            Light
          </button>{" "}
          |{" "}
          <button
            type="button"
            onClick={() => {
              setChecked(false);
            }}
          >
            Dark
          </button>
        </div> */}
    </footer>
  );
}

export default Footer;
